.summary {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
  font-weight: 600;
}

.title:focus {
  outline: none;
}

.title:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.label {
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 600;
}

.verdict {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

/* Joni, edge cases: every target at least 44 px, as the other Phase 2 screens */
.actions > *,
.row > button {
  min-height: 44px;
}
